export const GalleryItem = (data) => ({
  feedback_id: {
    '$oid': data._id.$oid, // eslint-disable-line
  },
  spot: data.spot,
  ...data.answers.data,
});

export const Gallery = (data) => data.map((item) => GalleryItem(item));
